import _join from "ramda/es/join";
import _pipe from "ramda/es/pipe";
import rejectNilOrEmpty from './rejectNilOrEmpty';

var joinNotNilOrEmptyWithSpace = _pipe(rejectNilOrEmpty, _join(' '));

export default joinNotNilOrEmptyWithSpace;